
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stake",
      function () {
        return require("private-next-pages/stake/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stake"])
      });
    }
  